<div class="form-group">
  <label *ngIf="!block.settings.hide_name" [for]="domId + slug" class="name">
    <span [class.text-danger]="blocksConfig.editable && blocksConfig.localizable && !block.localizedName(currentContentLocale, originalContentLocale)">
      {{block.localizedName(currentContentLocale, originalContentLocale, true)}}
    </span>
    <pl-required-indicator *ngIf="block.settings.required && blocksConfig.showRequiredIndicator && !ineligible" />
    <pl-readonly-indicator *ngIf="block.settings.readonly && blocksConfig.editable" />
  </label>

  <div class="position-relative">
    <input *ngIf="blocksConfig.editable || blocksConfig.submittable"
           #input="ngModel"
           [ngModel]="date"
           (blur)="formControl.markAsTouched()"
           (ngModelChange)="emit($event)"
           [class.empty]="!input.value"
           [class.is-invalid]="(!blocksConfig.editable || blocksConfig.preview) && (block.settings.validate || block.settings.required)  && formControl?.invalid && formControl?.touched"
           [class.is-placeholder]="date === null"
           [class.is-valid]="(!blocksConfig.editable || blocksConfig.preview) && (block.settings.validate || block.settings.required) && formControl?.touched && formControl?.valid"
           [class.text-danger]="(!blocksConfig.editable || blocksConfig.preview) && (block.settings.validate || block.settings.required)  && formControl?.invalid && formControl?.touched"
           [fontSizeEnabled]="isOverlay || block.settings.fontSize !== 16"
           [fontSize]="block.settings.fontSize"
           [gizmoDestinationInput]="input"
           [gizmoDestination]="this"
           [id]="domId + slug"
           [ngModelOptions]="{standalone: true}"
           [max]="noFutue ? max : null"
           [disabled]="ineligible || (block.settings.readonly && blocksConfig.submittable && !blocksConfig.editable)"
           [readonly]="(block.settings.readonly && !blocksConfig.editable) || (!blocksConfig.editable && !blocksConfig.submittable) || (isOverlay && blocksConfig.editable && !blockComponent?.selected)"
           [required]="block.settings.required && !blocksConfig.preview"
           [style.padding-bottom.px]="block.settings.paddingY"
           [style.padding-left.px]="block.settings.paddingX"
           [style.padding-right.px]="block.settings.paddingX"
           [style.padding-top.px]="block.settings.paddingY"
           class="form-control"
           type="date">

    <span *ngIf="(blocksConfig.editable || blocksConfig.submittable) && !date && (platform.IOS && !platform.BLINK)" class="ios-placeholder">{{'blocks.' + block.type + '.placeholder' | transloco}}</span>
  </div>

  <p *ngIf="!blocksConfig.editable && !blocksConfig.submittable"
     [class.form-control-overlay]="isOverlay"
     [class.form-control]="!isOverlay"
     [fontSizeEnabled]="isOverlay || block.settings.fontSize !== 16"
     [fontSize]="block.settings.fontSize"
     [id]="domId + slug"
     [style.padding-bottom.px]="block.settings.paddingY"
     [style.padding-left.px]="block.settings.paddingX"
     [style.padding-right.px]="block.settings.paddingX"
     [style.padding-top.px]="block.settings.paddingY">

    <b *ngIf="block.settings.hide_name && date && !isOverlay">{{block.settings.name}}: </b> {{date | translocoDate}}

    <span *ngIf="!date && !blocksConfig.printOptimized"
          class="placeholder">{{block.settings.placeholder ? block.settings.placeholder : ('blocks.' + block.type + '.placeholder' | transloco)}}</span>
  </p>

  <small *ngIf="block.localizedHelpText(currentContentLocale, originalContentLocale,true)"
         [id]="domId + slug + 'helptext'"
         [class.text-danger]="blocksConfig.editable && blocksConfig.localizable && !block.localizedHelpText(currentContentLocale, originalContentLocale)"
         class="form-text text-muted" aria-hidden="true">
    {{block.localizedHelpText(currentContentLocale, originalContentLocale, true)}}
  </small>

  <div
    *ngIf="(!blocksConfig.editable || blocksConfig.preview) && blocksConfig.validation && (block.settings.validate || block.settings.required) && !!formControl?.invalid && !!formControl?.touched"
    class="text-danger">
    <div *ngIf="formControl?.errors.required">
      {{'blocks.' + block.type + '.errors.required' | transloco}}
    </div>
  </div>
</div>

<pl-ineligibility-overlay *ngIf="ineligible"></pl-ineligibility-overlay>
